import React from "react";
import AudioPulse from "../audio-pulse/AudioPulse";
import cn from "classnames";

export default function CenterAudioPulse({
  volume,
  active,
  videoActive,
}) {
  const isVisible = active && volume > 0 && !videoActive;

  return (
    <div
      className={cn("absolute left-0 right-0 top-1/2 z-10 opacity-0 transition-all duration-300 ease-in-out pointer-events-none flex justify-center -translate-y-1/2", {
        "opacity-100": isVisible,
      })}
    >
      <div className="scale-[4] flex justify-center">
        <AudioPulse active={active} volume={volume} />
      </div>
    </div>
  );
} 